import type { SVGProps } from "react";

export function IconBlueThreeArrows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F7F8FE" />
      <path
        d="M39 32L31 40"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M32 31H40V39L32 31Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
      <path
        d="M39 17L16 40"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M32 16H40V24L32 16Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
      <path
        d="M24 17L16 25"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M17 16H25V24L17 16Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
    </svg>
  );
}
